/*
 * Authors: mariushirjanu
 * Created: 30/05/2023
 */

import { Injectable } from '@angular/core';
import { HttpDataService, IHttpDataCache } from '../../../../shared/http/http-data.service';

import { ILov } from '../../../../../type_definitions/datatypes';
import { ITaxInfo } from '../order-entry-data.service';

@Injectable()
export class OrderEntryChargesDataService {
  private cache:IHttpDataCache<any>;

  constructor(
    httpDataService:HttpDataService
  ) {
    this.cache = httpDataService.createCache();
  }

  public loadTaxInfo(webshopId:number, countryId:number, bpId:number, billingType:string, shipToCountryId:number, shipToStateCode:string, invoiceToCountryId?:number):Promise<ITaxInfo> {
    return this.cache.doGET(
      `rest/orderentry/webshops/${webshopId}/countries/${countryId}/taxinfo`,
      {
        bpId,
        billingType,
        shipToCountryId,
        shipToStateCode,
        invoiceToCountryId
      },
      undefined,
      'Error loading tax'
    );
  }

  public chargeTypes = ():Promise<ILov[]> => {
    return this.cache.doGET(
      'rest/orderentry/chargetypes',
      undefined,
      undefined,
      'Error loading charges'
    );
  };
}